<template>
  <el-dialog
    v-model="dialogVisible"
    append-to-body
    class="how-to-getcode-dialog"
    :close-on-click-modal="false"
    destroy-on-close
    :show-close="false"
    :width="800"
  >
    <template #header>
      <div class="how-to-getcode-dialog__header">
        <div class="how-to-getcode-dialog__title">{{ title }}</div>
        <button class="how-to-getcode-dialog__close" type="button" @click="dialogVisible = false">
          <i class="icon-close-large-line t-iconfont"></i>
        </button>
      </div>
    </template>

    <div class="how-to-getcode-dialog__body">
      <div class="how-to-getcode-dialog__content">
        <div class="how-to-getcode-dialog__title-text">打开群聊，滑动到底部</div>
        <div class="how-to-getcode-dialog__desc">
          在飞书内部群聊，点击右上角「...」→「设置」滑动至底部。
        </div>
      </div>

      <div class="how-to-getcode-dialog__image-wrap">
        <img alt="如何获取群聊会话 ID" class="how-to-getcode-dialog__image" :src="imageSrc" />
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'
import getLarkCodeImage from '@/assets/get-lark-code.png'

defineOptions({
  name: 'HowToGetCodeDialog'
})

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '如何获取群聊会话 ID'
  },
  imageSrc: {
    type: String,
    default: getLarkCodeImage
  }
})

const emits = defineEmits(['update:modelValue'])

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value)
})
</script>

<style lang="scss">
.how-to-getcode-dialog {
  margin-top: 15vh;
  border-radius: 12px;
  box-shadow: 0px 2px 15px 2px rgba(0, 0, 0, 0.05);
}

.how-to-getcode-dialog .el-dialog__header {
  border-bottom: none;
}

.how-to-getcode-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style lang="scss" scoped>
.how-to-getcode-dialog__header {
  display: flex;
  align-items: center;
  padding: 24px;
}

.how-to-getcode-dialog__title {
  flex: 1;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: #323233;
}

.how-to-getcode-dialog__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin-left: 8px;
  font-size: 16px;
  color: #969799;
  background: transparent;
  border: none;
  cursor: pointer;
}

.how-to-getcode-dialog__body {
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px;
  font-family: PingFang SC;
}

.how-to-getcode-dialog__content {
  display: flex;
  flex-direction: column;
}

.how-to-getcode-dialog__title-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #323233;
}

.how-to-getcode-dialog__desc {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #969799;
}

.how-to-getcode-dialog__image-wrap {
  margin-top: 12px;
  overflow: hidden;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
}

.how-to-getcode-dialog__image {
  display: block;
  width: 100%;
  height: auto;
}
</style>
